import { render, staticRenderFns } from "./EventModalCatalogNavigation.vue?vue&type=template&id=2254f372&scoped=true"
import script from "./EventModalCatalogNavigation.vue?vue&type=script&lang=js"
export * from "./EventModalCatalogNavigation.vue?vue&type=script&lang=js"
import style0 from "./EventModalCatalogNavigation.vue?vue&type=style&index=0&id=2254f372&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2254f372",
  null
  
)

export default component.exports